import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e76126a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBar_title" }, "侧边栏导航", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBar_tip" }, "最多可添加10个导航，选中可拖动排序", -1))
const _hoisted_4 = { class: "storehouse_list" }
const _hoisted_5 = { class: "storehouse_list_btn" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBar_list_title" }, "标题：", -1))
const _hoisted_8 = { class: "contentModal_content" }
const _hoisted_9 = { class: "contentModal_content_line" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "链接方式：", -1))
const _hoisted_11 = {
  key: 0,
  class: "contentModal_content_line"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "页"),
  /*#__PURE__*/_createTextVNode(" 面： ")
], -1))
const _hoisted_13 = {
  key: 1,
  class: "contentModal_content_line"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "内"),
  /*#__PURE__*/_createTextVNode(" 容： ")
], -1))
const _hoisted_15 = {
  key: 2,
  class: "contentModal_content_line"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "外部链接：", -1))
const _hoisted_17 = {
  key: 0,
  class: "topBar_modal"
}
const _hoisted_18 = { class: "topBar_modal_line" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_line_title" }, "跳转链接：", -1))
const _hoisted_20 = {
  key: 0,
  class: "topBar_modal_line"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_line_title" }, "站内页面：", -1))
const _hoisted_22 = {
  key: 1,
  class: "topBar_modal_line"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_line_title" }, "外部链接：", -1))

import { ref, withDefaults } from 'vue';
import Draggable from 'vuedraggable';
import { message, Modal, Radio } from 'ant-design-vue';
import emitter from '@/utils/mitt';
import http from '@/api/conentCenter/communal';
import { useRoute } from 'vue-router';
import { dragDrop } from '@/utils/format/dragDrop';

interface Props {
  custom: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar_setup',
  props: {
    custom: { default: '' }
  },
  setup(__props: any) {

const props = __props as { custom: any };

const route = useRoute();
const gatewayId = route.params.gatewayId;
const aModal = Modal;
const aRadioGroup = Radio.Group;



const topBar = ref({ ...props.custom });

const toVisualization = () => {
  emitter.emit('topBar', topBar.value);
};

// 删除
const deleteTopBar = (index: number) => {
  topBar.value.titleList.splice(index, 1);
  toVisualization();
};
// 添加
const addTopBar = () => {
  if (topBar.value.titleList.length == 10) {
    message.destroy();
    message.info('最多可添加10个导航');
    return;
  }
  topBar.value.titleList.push({
    id: topBar.value.titleList.length + 1,
    title: '',
    choice: 0,
    inside: undefined,
    insideDetails: undefined,
    outside: '',
  });
};

// 删除id
const deleteIndex = ref();
const getDelete = (e: number) => {
  deleteIndex.value = deleteIndex.value == e ? null : e;
};

// 链接设置
const linkModal = ref(false);
const openIndex = ref(0);
const openLink = (index: number) => {
  openIndex.value = index;
  linkModal.value = true;
  getSitePageLinks();
};
const choiceOptions = ref([
  {
    value: 0,
    label: '站内页面',
  },
  {
    value: 1,
    label: '外部链接',
  },
]);
const pageOptions = ref([
  { value: 1, label: '文章' },
  { value: 2, label: '图片' },
  { value: 3, label: '直播' },
  { value: 4, label: '文档' },
  { value: 5, label: '文章分类' },
  { value: 6, label: '图片分类' },
  { value: 7, label: '直播分类' },
  { value: 8, label: '文档分类' },
]);
const sitePageLinks = ref();
const getInsideLink = () => {
  topBar.value.titleList[openIndex.value].insideDetails = undefined;
  getSitePageLinks();
};
const getSitePageLinks = () => {
  const data = {
    portal_id: gatewayId,
    type: topBar.value.titleList[openIndex.value].inside || 1,
  };
  http.getSitePageLinks({ params: data }).then((res) => {
    sitePageLinks.value = [...res.data.data];
  });
};
const modalOk = () => {
  linkModal.value = false;
  toVisualization();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_unref(Draggable), {
      list: topBar.value.titleList,
      "item-key": "id",
      animation: 150,
      onChange: toVisualization,
      onDrop: _unref(dragDrop)
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: ($event: any) => (getDelete(index)),
              class: "topBar_list"
            }, [
              _hoisted_7,
              _createVNode(_component_a_input, {
                placeholder: "请输入标题",
                value: element.title,
                "onUpdate:value": ($event: any) => ((element.title) = $event),
                onChange: toVisualization,
                maxlength: 6
              }, null, 8, ["value", "onUpdate:value"]),
              _createVNode(_component_a_button, {
                onClick: ($event: any) => (openLink(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("链接设置")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _withDirectives(_createVNode(_component_svg_icon, {
                class: "topBar_list_delete",
                "icon-class": "delete_circular",
                onClick: ($event: any) => (deleteTopBar(index))
              }, null, 8, ["onClick"]), [
                [_vShow, deleteIndex.value == index]
              ])
            ], 8, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    }, 8, ["list", "onDrop"]),
    _createVNode(_component_a_button, {
      class: "topBar_add",
      onClick: addTopBar
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_svg_icon, { "icon-class": "increase" })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" 添加导航 ")
      ]),
      _: 1
    }),
    (linkModal.value)
      ? (_openBlock(), _createBlock(_unref(aModal), {
          key: 0,
          visible: linkModal.value,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((linkModal).value = $event)),
          centered: "",
          title: "链接设置",
          onOk: modalOk
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_unref(aRadioGroup), {
                  options: choiceOptions.value,
                  value: topBar.value.titleList[openIndex.value].choice,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((topBar.value.titleList[openIndex.value].choice) = $event))
                }, null, 8, ["options", "value"])
              ]),
              (topBar.value.titleList[openIndex.value].choice == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_a_select, {
                      class: "line_select",
                      value: topBar.value.titleList[openIndex.value].inside,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((topBar.value.titleList[openIndex.value].inside) = $event)),
                      placeholder: "请选择页面",
                      options: pageOptions.value,
                      onChange: getInsideLink
                    }, null, 8, ["value", "options"])
                  ]))
                : _createCommentVNode("", true),
              (topBar.value.titleList[openIndex.value].choice == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_a_select, {
                      class: "line_select",
                      value: topBar.value.titleList[openIndex.value].insideDetails,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((topBar.value.titleList[openIndex.value].insideDetails) = $event)),
                      "show-search": "",
                      placeholder: 
              '请选择' + pageOptions.value[topBar.value.titleList[openIndex.value].inside ? topBar.value.titleList[openIndex.value].inside - 1 : 0].label
            
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sitePageLinks.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item,
                            value: item.id,
                            label: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]))
                : (topBar.value.titleList[openIndex.value].choice == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_a_input, {
                        class: "line_select",
                        placeholder: "请输入外部链接",
                        value: topBar.value.titleList[openIndex.value].outside,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((topBar.value.titleList[openIndex.value].outside) = $event))
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_unref(aRadioGroup), {
                      options: choiceOptions.value,
                      value: topBar.value.titleList[openIndex.value].choice,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((topBar.value.titleList[openIndex.value].choice) = $event))
                    }, null, 8, ["options", "value"])
                  ]),
                  (topBar.value.titleList[openIndex.value].choice == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_a_select, {
                          class: "modal_line_select",
                          value: topBar.value.titleList[openIndex.value].inside,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((topBar.value.titleList[openIndex.value].inside) = $event)),
                          "show-search": "",
                          placeholder: "请选择站内链接",
                          options: pageOptions.value
                        }, null, 8, ["value", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (topBar.value.titleList[openIndex.value].choice == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_a_input, {
                          class: "modal_line_select",
                          placeholder: "请输入外部链接",
                          value: topBar.value.titleList[openIndex.value].outside,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((topBar.value.titleList[openIndex.value].outside) = $event))
                        }, null, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})